export default "__VITE_ASSET__DKXr_VRk__"